import { render, staticRenderFns } from "./storebatch.vue?vue&type=template&id=1920bd98&scoped=true&"
import script from "./storebatch.vue?vue&type=script&lang=js&"
export * from "./storebatch.vue?vue&type=script&lang=js&"
import style0 from "./storebatch.vue?vue&type=style&index=0&id=1920bd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920bd98",
  null
  
)

export default component.exports